import React from 'react';
import { NumberField as BaseNumberField } from '@base-ui/react/number-field';
import { Box, Button, Typography } from '@mui/material';
import { numberSpinnerStyles } from './eventDetailsStyles';

const NumberSpinner = ({ label, min = 1, max, value, onChange, disabled, error, helperText }) => {
  const inputId = React.useId();

  const handleValueChange = (nextValue) => {
    if (nextValue === null) {
      onChange(min);
      return;
    }
    onChange(nextValue);
  };

  return (
    <Box onClick={(event) => event.stopPropagation()}>
      <Typography component="label" htmlFor={inputId} variant="caption" color={error ? 'error' : 'text.secondary'} sx={{ display: 'block', mb: 0.75 }}>
        {label}
      </Typography>
      <BaseNumberField.Root
        id={inputId}
        min={min}
        max={max}
        step={1}
        value={value}
        onValueChange={handleValueChange}
        disabled={disabled}
      >
        <BaseNumberField.Group render={<Box sx={numberSpinnerStyles.group(error, disabled)} />}>
          <BaseNumberField.Decrement
            render={
              <Button type="button" disabled={disabled} sx={numberSpinnerStyles.button}>
                -
              </Button>
            }
          />
          <BaseNumberField.Input render={<Box component="input" sx={numberSpinnerStyles.input} />} />
          <BaseNumberField.Increment
            render={
              <Button type="button" disabled={disabled} sx={numberSpinnerStyles.button}>
                +
              </Button>
            }
          />
        </BaseNumberField.Group>
      </BaseNumberField.Root>
      {helperText && (
        <Typography variant="caption" color={error ? 'error' : 'text.secondary'} sx={{ display: 'block', mt: 0.75 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default NumberSpinner;
